export default "__VITE_ASSET__DTcARCqQ__"